import { useMemo } from 'react'
import { Combobox } from '@/components/ui/combobox'
import { buildIconOptions } from '@/lib/icons'

// Seletor de ícone (emoji) em LISTA — substitui o campo de texto livre onde a
// pessoa tinha que saber/colar um emoji sozinha. O botão mostra só o emoji
// (grande, sem o nome do lado — cabe em colunas estreitas); a lista aberta
// mostra "emoji  nome" e é buscável (ex.: digitar "banco" acha 🏦).
export function IconPicker({
  value,
  onChange,
  noneLabel,
  searchPlaceholder,
  placeholderEmoji = '🙂',
  className,
  'aria-label': ariaLabel,
}: {
  value: string
  onChange: (v: string) => void
  /** Texto da opção "sem ícone" — muda conforme o contexto (categoria vs. conta). */
  noneLabel: string
  searchPlaceholder?: string
  /** Emoji mostrado no botão quando não há valor escolhido (ex.: padrão do tipo de conta). */
  placeholderEmoji?: string
  className?: string
  'aria-label'?: string
}) {
  const options = useMemo(() => buildIconOptions(noneLabel), [noneLabel])
  return (
    <Combobox
      className={className}
      options={options}
      value={value}
      onChange={onChange}
      placeholder={noneLabel}
      searchPlaceholder={searchPlaceholder}
      aria-label={ariaLabel}
      triggerContent={<span className="text-lg leading-none">{value || placeholderEmoji}</span>}
    />
  )
}
